import { render, staticRenderFns } from "./add-with-register-code.vue?vue&type=template&id=740733b2"
import script from "./add-with-register-code.vue?vue&type=script&lang=js"
export * from "./add-with-register-code.vue?vue&type=script&lang=js"
import style0 from "./add-with-register-code.vue?vue&type=style&index=0&id=740733b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports